var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-dialog',{attrs:{"open":_vm.confirmClearOpen,"header":_vm.confirmClear.header,"query-parameter":"confirmBewerbStatus"},on:{"reply":_vm.processConfirm}},[_vm._v(" "+_vm._s(_vm.confirmClear.question)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }